import { addDisplayName, flowMax } from 'ad-hok'
import { FC } from 'react'
import { ProductFeatureInput } from 'shared/src/api/types'

import { addTranslationHelpers } from 'utils/addTranslationHelpers'
import { FormProps } from './resource'
import { ResourceSelectField } from './ResourceSelectField'

export const ProductFeatureForm: FC<FormProps<Partial<ProductFeatureInput>>> =
  flowMax(
    addDisplayName('ProductFeatureForm'),
    addTranslationHelpers,
    ({ values, onChange, errors, t }) => (
      <div>
        <ResourceSelectField
          id="productId"
          label={t('admin.resources.productFeatures.fields.product')}
          error={errors.productId}
          resourceName="products"
          selectedId={values.productId}
          onChange={(productId) => onChange({ ...values, productId })}
          focusOnMount
        />
      </div>
    )
  )
